
import {map, flatMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseService, AppSettingsService, AuthenticationService, ServiceManager } from 'iui-iconectiv-lib';
import { GenericResponse } from '../shared';


const PUT_ACCOUNT = '/api/account';
const GET_SERVICE_AGREEMENT_URL = '/api/account/serviceagreement/';



@Injectable()
export class AccountCompletionService extends BaseService {

  constructor(
    serviceManager: ServiceManager,
    private http: HttpClient,
    private appSettings: AppSettingsService,
    private authService: AuthenticationService,
  ) {

    super(serviceManager);

  }


  putAccountCompletion(accountJson: string): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + PUT_ACCOUNT;
      this.log.debug(`url=${url}, accountJson=${accountJson}`);
      return this.http.put(url, accountJson, {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken())
      });
    })));
  }

  getServiceAgreement(version: string): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(map(settings => {
      const url = this.getServer(settings) + PUT_ACCOUNT + "/serviceagreement/" + version;
      console.log("URL: " + url);
      this.http.get(url,{  headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
        .append('Authorization', this.authService.getToken()),
        responseType: 'text'}).pipe(map(res => {
          const r = this.parseToType<GenericResponse>(res);
          return r;
        }));;
    })));
  }

  getServiceAgreementUrl(): Observable<string> {
    return this.emitObservable(
      this.appSettings.getSettings().pipe(map(settings => {
        return this.getServer(settings) + GET_SERVICE_AGREEMENT_URL;
      }))
    );
  }


}
